import React from 'react';
import { FiSearch, FiTruck, FiClock, FiCheckCircle } from 'react-icons/fi';
import { BiSearchAlt } from 'react-icons/bi';
import { GiSmartphone } from 'react-icons/gi';

const HowItWorks = ({ isDarkMode }) => {
  const steps = [
    {
      icon: <BiSearchAlt className="text-xl" />,
      title: "Check Price",
      description: "Search for your used mobile phone, tablet, or smartwatch on our website, select device condition from options, and instantly get the best price for old phone or other gadgets.",
    },
    {
      icon: <FiTruck className="text-xl" />,
      title: "Schedule Pick-up",
      description: "Select a date and time that suits you, and our team will pick up your second-hand mobile, tablet, or smartwatch right from your doorstep — seamless mobile resale platform experience.",
    },
    {
      icon: <FiClock className="text-xl" />,
      title: "Instant Payment, Complete Assurance",
      description: "Our expert technician will diagnose your old phone, used tablet or used smartwatch on the spot, ensuring you get the best value. Receive instant cash for old Mobile phone & other old Gadgets along with a valid sale receipt for complete peace of mind.",
    }
  ];

  return (
    <section className="mb-5">
      {/* Steps Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        {steps.map((step, index) => (
          <div
            key={index}
            className={`relative p-4 rounded-xl transition-all hover:shadow-md ${
              isDarkMode
                ? 'bg-gray-800 hover:bg-gray-750' 
                : 'bg-white hover:shadow-lg border border-gray-100'
            }`}
          >
            <div className="flex items-start gap-3">
              {/* Green Icon Container */}
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center shrink-0 shadow-sm ${
                isDarkMode 
                  ? 'bg-green-600/20 text-green-400' 
                  : 'bg-green-100 text-green-600'
              }`}>
                {step.icon}
              </div>
              
              <div className="flex-1">
                {/* Title */}
                <h3 className={`text-sm font-semibold mb-1 ${
                  isDarkMode ? 'text-white' : 'text-gray-800'
                }`}>
                  {step.title}
                </h3>

                {/* Description */}
                <p className={`text-xs leading-relaxed ${
                  isDarkMode ? 'text-gray-400' : 'text-gray-600'
                }`}>
                  {step.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Bottom Badge */}
      <div className={`mt-4 p-3 rounded-lg ${
        isDarkMode 
          ? 'bg-gray-800 border border-gray-700' 
          : 'bg-white border border-gray-100 shadow-sm'
      }`}>
        <div className="flex items-center justify-center gap-2 flex-wrap">
          <div className="flex -space-x-1.5">
            <div className={`w-6 h-6 rounded-full flex items-center justify-center text-white text-[10px] border-2 ${
              isDarkMode ? 'border-gray-800' : 'border-white'
            } bg-green-500`}>
              <GiSmartphone size={10} />
            </div>
            <div className={`w-6 h-6 rounded-full flex items-center justify-center text-white text-[10px] border-2 ${
              isDarkMode ? 'border-gray-800' : 'border-white'
            } bg-green-600`}>
              <GiSmartphone size={10} className="rotate-90" />
            </div>
            <div className={`w-6 h-6 rounded-full flex items-center justify-center text-white text-[10px] border-2 ${
              isDarkMode ? 'border-gray-800' : 'border-white'
            } bg-green-700`}>
              <FiClock size={10} />
            </div>
          </div>
          <span className={`text-xs font-medium flex items-center gap-1 ${
            isDarkMode ? 'text-gray-300' : 'text-gray-700'
          }`}>
            <FiCheckCircle className="text-green-500" size={14} />
            100% Safe & Secure • Instant Payment • Free Pickup
          </span>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;